/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberShiftIdAppointmentsQueryResponse, GetApiBarberShiftIdAppointmentsPathParams, GetApiBarberShiftIdAppointments400, GetApiBarberShiftIdAppointments401, GetApiBarberShiftIdAppointments403, GetApiBarberShiftIdAppointments404, GetApiBarberShiftIdAppointments500 } from "../entities/GetApiBarberShiftIdAppointments";

function getGetApiBarberShiftIdAppointmentsUrl(id: GetApiBarberShiftIdAppointmentsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/barber/shift/${id}/appointments` as const }
  return res
}

/**
 * @description Получить очередь для рабочего места мастера
 * @summary Получить мою очередь
 * {@link /api/barber/shift/:id/appointments}
 */
export async function getApiBarberShiftIdAppointments(id: GetApiBarberShiftIdAppointmentsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBarberShiftIdAppointmentsQueryResponse, ResponseErrorConfig<GetApiBarberShiftIdAppointments400 | GetApiBarberShiftIdAppointments401 | GetApiBarberShiftIdAppointments403 | GetApiBarberShiftIdAppointments404 | GetApiBarberShiftIdAppointments500>, unknown>({ method : "GET", url : getGetApiBarberShiftIdAppointmentsUrl(id).url.toString(), ... requestConfig })
  return res.data
}